import { SxProps } from '@mui/material';

export const Container: SxProps = {
    marginBottom: '16px',
    '&:last-child': {
        marginBottom: 0,
    },
};

export const TextStyles: SxProps = {
    fontSize: '14px',
    display: 'flex',
    gap: '6px',
    alignItems: 'center',
};

export const ValueStyles: SxProps = {
    textAlign: 'right',
    fontWeight: '700',
};

export const SummaryBox: SxProps = {
    backgroundColor: '#d6ebea',
    borderRadius: '20px',
    padding: '16px',
    margin: '20px 0',
};
